import { graphql } from 'src/graphql';

import { MessagesFields } from 'src/fragments/messagesFields.fragment';

export const MarkMultipleMessagesAsSeen = graphql(
  `
    mutation markMultipleMessagesAsSeen($_messages_id: [ID]!) {
      markMultipleMessagesAsSeen(_messages_id: $_messages_id) {
        ...MessagesFields
      }
    }
  `,
  [MessagesFields],
);
